import React, { FC } from 'react';
import { VisualHeaderLayout } from 'components/ModalKit/VisualHeaderLayout/VisualHeaderLayout';
import Typography from 'components/Typography/Typography';
import { useWindowSize } from 'hooks/breakpoints';
import { useTranslation } from 'react-i18next';
import { useDeliveryAddressForm } from 'routes/DeliveryAddressModal/hooks/useDeliveryAddressForm';
import { DELIVERY_ADDRESS_MODAL } from '../../DeliveryAddressModal.const';
import styles from './DeliveryAddressModalHeader.module.scss';

export const DeliveryAddressModalHeader: FC = () => {
  const { t } = useTranslation();
  const { isDesktop } = useWindowSize();
  const { isReviewing } = useDeliveryAddressForm();

  const titleText = isReviewing
    ? t('deliveryAddressModal.review_title')
    : t('deliveryAddressModal.title');

  return (
    <VisualHeaderLayout
      className={styles.header}
      data-testid={DELIVERY_ADDRESS_MODAL.id}
      iconName="mappin" iconSize={64}
    >
      <VisualHeaderLayout.Title>
        <Typography.Heading1>{titleText}</Typography.Heading1>
      </VisualHeaderLayout.Title>
      {isDesktop && (
        <VisualHeaderLayout.Subtitle>
          <Typography.Body>
            {t('deliveryAddressModal.subtitle')}
          </Typography.Body>
        </VisualHeaderLayout.Subtitle>
      )}
    </VisualHeaderLayout>
  );
};
